import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltVideoEditorPlayerZoomButtonWireframe from '../../VeltVideoEditorPlayerZoomButtonWireframe';
var VeltVideoEditorPlayerTimelineScaleWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-timeline-scale-wireframe", __assign({}, transformedProps), children));
};
VeltVideoEditorPlayerTimelineScaleWireframe.ZoomButton = VeltVideoEditorPlayerZoomButtonWireframe;
export default VeltVideoEditorPlayerTimelineScaleWireframe;
